var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#1B1D1E",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.66 9.395 1.96-.4L14 5.95l.068.247c3.07.823 4.868 4.09 4.011 7.287-.028.106-.06.21-.093.314l1.481 1.48c.188-.41.345-.844.467-1.297 1.144-4.27-1.25-8.617-5.348-9.716l-.171.17 2.044-2.305L14.963.803 11.665 4.52l.996 4.875Zm-7.708 1.108c-.857 3.197.941 6.464 4.01 7.286l.001.003-.581-2.849 1.96-.4.995 4.875-3.298 3.716-1.496-1.327 1.86-2.097c-4.073-1.117-6.446-5.449-5.306-9.704a8.23 8.23 0 0 1 .745-1.851l1.433 1.432c-.13.292-.238.598-.323.916Zm.742-6.322L4.28 5.595l13.312 13.313 1.414-1.414L5.694 4.18Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncOff);
export default __webpack_public_path__ + "static/media/sync-off.08541e3c.svg";
export { ForwardRef as ReactComponent };